export const columns = function () {
    return [
        {
            prop: 'username',
            label: '工号',
            fixed: 'left',
            minWidth: 150
        },
        {
            prop: 'realname',
            label: '姓名',
        },
        {
            prop: 'org_name',
            label: '所属机构',
        },
        {
            prop: 'group_name',
            label: '岗位名称',
			minWidth: 150
        },
        {
            prop: 'user_type',
            label: '用户类型',
        },
        {
            prop: 'phone',
            label: '手机号',
        },
        {
            prop: 'is_enabled',
            label: '状态',
            render: ({ is_enabled }) => {
                return is_enabled == 0 ? "禁用" : "启用"
            }
        },
        {
            prop: 'remark',
            label: '备注',
        },
        {
            prop: 'handle',
            label: '操作',
            fixed: 'right',
            minWidth: 200
        }
    ]
}

export default {}